// The stream's bar (the broadcast only, src/web/layout.rs): the bout on now and how, set on every channel change and again at the seal.
import { $ } from "./dom.ts";

export function initOverlay() {
  const slot = $("[data-tv-bout]");
  if (!slot) return;
  const bout = $("article.bout");
  if (!bout) {
    slot.textContent = "between bouts";
    slot.dataset.mode = "";
    return;
  }
  const mode = bout.dataset.replay
    ? "replay"
    : bout.dataset.live && !bout.dataset.done && !bout.dataset.verdict
      ? "live"
      : "final";
  slot.textContent = `bout ${bout.dataset.bout} · ${mode}`;
  slot.dataset.mode = mode;
}
